export default __webpack_public_path__ + "static/media/ajax-loader.3fbcb07e.gif";